angular.module('core')
    .directive('focusElement', function ($timeout) { //musi być directive
        return {
            restrict: 'A',
            scope: false, //musi być scope: false, aby nie było konfliktów z innymi dyrektywami
            link: function (scope, element) {
                $timeout(() => element.focus(), 100);
            }
        };
    })
    .directive('focus', function ($timeout) {
        return {
            scope: {
                trigger: '@focus'
            },
            link: function (scope, element) {
                scope.$watch('trigger', function (value) {
                    if (value === "true") {
                        $timeout(function () {
                            element[0].focus();
                        }, 300);
                    }
                });
            }
        }
    })
    .service('FocusService', function ($rootScope) {
        this.focus = function (elementId) {
            setTimeout(() => {
                const element = document.getElementById("otherRepresentativeInput")
                if (element) {
                    element.focus()
                }
            }, 100)
        };
    })
